import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs } from "swiper";
import "../../css/pages/slider.scss";
import { iImageContent } from "./ContentShow";

interface Props {
  mediaList: iImageContent[];
}
const SingleContentSlider: React.FC<Props> = (Props) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  const contentTitles = Props.mediaList.map((content) => {
    return (
      <SwiperSlide key={content.id}>
        <img src={require(`../../${content.path}`)} alt="logo" />
      </SwiperSlide>
    );
  });

  return (
    <>
      <Swiper
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {contentTitles}
      </Swiper>
    </>
  );
};
export default SingleContentSlider;
